import { render, staticRenderFns } from "./withdrawalsRefund.vue?vue&type=template&id=0f4c0df5&scoped=true&"
import script from "./withdrawalsRefund.vue?vue&type=script&lang=ts&"
export * from "./withdrawalsRefund.vue?vue&type=script&lang=ts&"
import style0 from "./withdrawalsRefund.vue?vue&type=style&index=0&id=0f4c0df5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c0df5",
  null
  
)

export default component.exports